import { BitbucketIcon } from '@atlaskit/logo';
import { Option } from 'funfix-core';
import { Map, Set } from 'immutable';
import React from 'react';
import { makeReactContextIcon } from '../../records/Context';
import { makeErrorTranslation } from '../../records/ErrorTranslation';
import { makeAddonDiscoveryConfig, makeHostConfig } from '../../records/HostConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export default makeHostConfig({
  addonDiscovery: makeAddonDiscoveryConfig({
    featuredContentOverride: Option.empty(),
    productKey: 'bitbucket',
    hiddenFilters: Map({
      sort: true,
      moreFilters: Set(['free'])
    })
  }),
  analytics: {
    productName: 'bitbucket',
    getSubproduct: _ => {
      /* Bitbucket has no subproduct */
    }
  },
  errors: Map({
    AddonDefinitionNotFoundError: makeErrorTranslation({
      title: "We couldn't find the app",
      description: "It's possible the link to the app is broken."
    }),
    DescriptorFetchError: makeErrorTranslation({
      title: "We couldn't find the app",
      description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
      validationError: true
    }),
    InstallationConflictError: makeErrorTranslation({
      title: "We're seeing double!",
      description: 'The app is already installed.'
    }),
    InvalidAddonOriginError: makeErrorTranslation({
      title: "This app isn't registered",
      description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
      validationError: true
    }),
    InvalidDefinitionDetailsQueryError: makeErrorTranslation({
      title: "The URL isn't formatted correctly",
      description: 'Please enter a valid installation URL, beginning with http: or https:',
      validationError: true
    }),
    InvalidDescriptorError: makeErrorTranslation({
      title: "This app isn't working quite right",
      description: 'The app at that installation URL seems to be broken. ' + 'Please reach out to our Support team, so we can get it fixed.',
      showTID: true
    }),
    default: makeErrorTranslation({
      title: 'We ran into a little trouble',
      description: 'It might just be a hiccup. Try again in a bit.',
      showTID: true
    })
  }),
  featureFlags: {
    productName: 'bitbucket'
  },
  globalContext: Option.some({
    icon: Option.some(makeReactContextIcon(_ref => {
      let {
        label,
        size
      } = _ref;
      return /*#__PURE__*/_jsx(BitbucketIcon, {
        label: label,
        size: size
      });
    }))
  }),
  name: 'Bitbucket',
  installationLocation: 'Bitbucket',
  isCloseable: false,
  supportsManage: false,
  removeFromSite: {
    actionSummary: appName => "Remove ".concat(appName, " from Bitbucket"),
    confirmation: appName => "You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
    successNotification: appName => "".concat(appName, " was removed")
  }
});